import { defineComponent as _defineComponent } from 'vue'

import { ref, onMounted } from 'vue';
import axios from 'axios';

export default /*#__PURE__*/_defineComponent({
  __name: 'CmsList',
  setup(__props) {

const cmsMemberList = ref([]);
const getCmsMemberList = async () => {
  try {
    const response = await axios.get('/api/cms/getCmsMemberList');
    if (response.data.success) {
      cmsMemberList.value = response.data.data;
    } else {
      console.error('CMS 목록 가져오기 중 에러 발생:', response.data.message);
    }
  } catch (error) {
    console.error('CMS 목록 가져오기 중 에러 발생:', error);
    throw error;
  }
}
onMounted(() => {
  getCmsMemberList();
});

return (_ctx: any,_cache: any) => {
  return " CMS 자동이체 "
}
}

})